/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Folder_Name_Invalid_CharsInputs */



/**
* | output |
* | --- |
* | "Folder name contains invalid characters" |
*
* @param {Spaces_Folder_Name_Invalid_CharsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_folder_name_invalid_chars = /** @type {((inputs?: Spaces_Folder_Name_Invalid_CharsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Folder_Name_Invalid_CharsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Ordnername enthält ungültige Zeichen")
	return /** @type {LocalizedString} */ ("Folder name contains invalid characters")
});